import type { RouteLocationRaw } from 'vue-router';

import { generateMenuItems, routeDefinitions } from '@/router/route-config';

export interface MenuItem {
  id: string;
  label: string;
  icon?: string;
  to?: RouteLocationRaw;
  permission?: string;
  children?: MenuItem[];
  items?: MenuItem[];
  badge?: string | number;
  separator?: boolean;
  hideFromMenu?: boolean;
}

function convertToMenuItems(generatedItems: ReturnType<typeof generateMenuItems>): MenuItem[] {
  return generatedItems.map(item => {
    const menuItem: MenuItem = {
      id: item.route?.name ?? item.label,
      label: item.label,
      icon: item.icon,
      permission: item.permission,
    };

    if (item.route) {
      menuItem.to = { name: item.route.name };
    }

    if (item.items && item.items.length > 0) {
      menuItem.children = convertToMenuItems(item.items);
    }

    return menuItem;
  });
}

export const adminMenuConfig: MenuItem[] = convertToMenuItems(generateMenuItems(routeDefinitions, 'employee', 'main'));

export const adminUserMenuConfig: MenuItem[] = convertToMenuItems(
  generateMenuItems(routeDefinitions, 'employee', 'user'),
);

export const customerMenuConfig: MenuItem[] = convertToMenuItems(
  generateMenuItems(routeDefinitions, 'customer', 'main'),
);

export const customerUserMenuConfig: MenuItem[] = convertToMenuItems(
  generateMenuItems(routeDefinitions, 'customer', 'user'),
);
